<div
  class="page-loading"
  role="status"
  aria-live="polite"
  aria-label="Loading content"
  fxFlex="100"
  fxLayout="column nowrap"
  fxFlex.mm-mobile="0 0 auto"
  fxLayoutAlign="center center"
>
  <div class="page-loading__loader" aria-hidden="true">
    <div class="page-loading__loader__dot page-loading__loader__dot--first"></div>
    <div class="page-loading__loader__dot page-loading__loader__dot--second"></div>
    <div class="page-loading__loader__dot page-loading__loader__dot--third"></div>
    <div class="page-loading__loader__dot page-loading__loader__dot--fourth"></div>
    <div class="page-loading__loader__dot page-loading__loader__dot--fifth"></div>
  </div>
  <p class="page-loading__text">
    {{ 'CATALOG.CATALOG_PAGE.LOADING' | translate }}
  </p>
</div>
